import React from 'react'
import { Typography, type TypographyProps, Skeleton, styled } from '@mui/material'
import { GenericLoader } from '../GenericLoader'
import type { LoadingProps } from '../LoadingProps'

const CaptionSkeleton = styled(Skeleton)`
    height: 12px;
    margin: 4px 0;
`

const BlockTypography = styled(Typography)`
    display: block;
`
interface Props extends LoadingProps, Omit<TypographyProps, 'width'> {}

export const LoaderCaption: React.FC<Props> = ({ loading, width, children, align, ...rest }: Props) => {
    let alignSkeleton: 'left' | 'center' | 'right' | undefined
    if (align === 'left' || align === 'center' || align === 'right') {
        alignSkeleton = align
    }

    return (
        <GenericLoader
            loading={loading}
            SkeletonComponent={CaptionSkeleton}
            skeletonProps={{ width }}
            alignSkeleton={alignSkeleton}
        >
            <BlockTypography {...rest} align={align} variant="caption">
                {children}
            </BlockTypography>
        </GenericLoader>
    )
}
